<!--
  - Copyright (c) 2021. Trade Research Advisory (Pty) Ltd, P.O.Box 336, Cornwall Hill, Irene, 0178
  - #  This file forms part of the Trade-DSM application frontend.
  - #  https://github.com/Tooblippe/trade-dsm-frontend
  -->

<template>
  <v-expansion-panel class="mt-1">
    <v-expansion-panel-header class="trade-blue ma-0">
      <span>
        {{ filter_data['name'] }}
      </span>

      <span class="yellow--text caption text-right font-italic ma-0 pa-0">
        {{ advanced ? ' (advanced)' : ' (basic)' }}
      </span>

      <template v-slot:actions>
        <v-icon color="yellow">$expand</v-icon>
      </template>
    </v-expansion-panel-header>

    <v-expansion-panel-content class="mt-2">
      <template v-for="entry in filter_data['entries']">

        <v-main
            v-if="
            entry.filter_class === 'basic' ||
            entry.filter_class === 'basic' ||
            (entry.filter_class === 'advanced' && advanced)
          "
            :key="entry.id"
            class="ma-0 pa-0 filterItem"
        >
          <v-container class="ma-0 pa-0" fluid>
            <v-layout
                :class="{'orange lighten-2': entry.last_selected}"
                class="pa-0 ma-0 justify-space-between align-center"
                row
            >
              <div class="ma-0 pa-0" style="width: 5px">
                <span class="green--text text-h6">
                  {{ entry.selected_value.length > 0 ? '✓' : '' }}
                </span>
              </div>
              <v-flex class="ma-0 pa-0 body-2 font-weight-thin sm5">
                <v-tooltip top color="success" max-width="200" :disabled="entry.explanation.length <= 11">
                  <template v-slot:activator="{ on, attrs }">
                <span
                    v-on="on"
                    :class="{
                    filter_heading: entry.indent === 1 || entry.indent === 0,
                    filter_sub: entry.indent === 2,
                  }"
                >{{ entry.name }}
                  {{
                    entry.display_unit === 'currency' ? '[' + currencyString + ']'  : ''
                  }}

                </span>
                  </template>
                  <span>{{ entry.explanation }}</span>
                </v-tooltip>
              </v-flex>
              <v-flex class="ma-0 pa-0  sm6">
                <dropdown_filter
                    v-if="entry.type === 'dropdown'"
                    :entry="entry"
                    :filter_name="filter_data.key"
                    :filters_updating_status="filters_updating_status"
                    :multiple="entry.type === 'dropdown' ? true : false"
                    :filters_changed="filters_changed"
                    class="ma-0 pa-0 ml-12"
                >"
                </dropdown_filter>
                <yes_no_filter
                    v-else-if="entry.type === 'yesno'"
                    :entry="entry"
                    :filter_name="filter_data.key"
                    class="ma-0 pa-0 ml-12"
                    :filters_updating_status="filters_updating_status"
                >
                </yes_no_filter>
                <yes_no_filter_direction
                    v-else-if="entry.type === 'yesnodirection'"
                    :entry="entry"
                    :filter_name="filter_data.key"
                    class="ma-0 pa-0 ml-12"
                    :filters_updating_status="filters_updating_status"
                >
                </yes_no_filter_direction>
                <span v-else class="text-center">
                  {{ entry.value }}
                </span>
              </v-flex>
            </v-layout>
          </v-container>
        </v-main>
      </template>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import yes_no_filter from '@/components/trade-dsm-application/left-side-bar/filter_componenets/yes_no_filter';
import dropdown_filter from '@/components/trade-dsm-application/left-side-bar/filter_componenets/dropdown_filter';
import yes_no_filter_direction
  from "@/components/trade-dsm-application/left-side-bar/filter_componenets/yes_no_filter_direction.vue";
export default {
  name: 'filter_group',

  components: {yes_no_filter_direction, yes_no_filter, dropdown_filter},

  props: {
    filter_name: String,
    filter_data: Object,    //entry
    advanced: Boolean,
    update_function: Function,
    filters_updating_status: Boolean,
    filters_changed: Boolean
  },

  mounted() {
    this.$forceUpdate();
  },
  data: function () {
    return {
      first_query: true,
    };
  },
};
</script>

<style scoped>
.filter_heading {
  font-weight: bold;
}

.filter_sub {
  margin-left: 10px;
  color: black;
  font-weight:390;
  padding :0
}
</style>
